module.exports = __webpack_public_path__ + "static/isometric-why-msm-e05370d7692c04643d95a512d46e72b0.svg";